import { useState } from 'react'

import UserModal from '../components/Modal'

import { useParams, useNavigate } from 'react-router-dom'
import { BUY_ENERGY, getSingleEnergy, TOKEN } from '../helpers/api';
import { useEffect } from 'react';

function BuyElectricity() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [modalItem, setModalItem] = useState("");
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (modalItemValue) => { setShow(true); setModalItem(modalItemValue) };
    const [data, setData] = useState({
        price: 0,
        quantity: 0
    })


    useEffect(() => {
        getData()
    }, [])



    const [quantity, setQuantity] = useState({
        price: 0,
        energyquantity: "",
        isGreen: ""
    })


    const handleQuantity = (event) => {
        if (parseInt(data?.quantity) >= parseInt(event.target.value) && parseInt(event.target.value) > 0) {
            setQuantity({ ...quantity, energyquantity: event.target.value, price: (data.price * parseInt(event.target.value)) })
        }
        else if (event.target.value == "") {
            setQuantity({ ...quantity, energyquantity: event.target.value, price: "" })
        }

        // setQuantity({ ...quantity, energyquantity: event.target.value, price: (data.price * parseInt(event.target.value)) })

    }



    const getData = async () => {
        try {
            const response = await getSingleEnergy({ id: id })
            setData(response.message)
            setQuantity({ ...quantity, energyquantity: response.message.quantity, price: response.message.price * response.message.quantity })
            console.log(response);
        }

        catch (e) {
            console.log(e);
        }
    }



    const buyEnergy = async () => {
        try {
            const payload = {
                sellerid: data?.sellerid?._id,
                price: quantity.price,
                energyid: id,
                quantity: quantity.energyquantity,
                isGreen: data.isGreen,
                avaialableQty: data.quantity
            }
            const response = await BUY_ENERGY(payload)
            if (response.success) {
                alert("created")
                navigate("/marketplace")
            }
        }
        catch (e) {
            console.log(e);
            // alert("not created")
        }
    }


    return (
        <>
            {/* <button onClick={() => TOKEN()}> get token</button> */}
            <section className='buy_electricity'>
                <div className="container">
                    <div className="card jc-center">
                        <h3>Buy Electricity</h3>
                        <div className="mb-3">
                            <label className="form-label mb-2">Price per kwh</label>
                            <input type="text" disabled className="form-control" value={`$ ${quantity.price ? quantity.price : "0"}`} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label mb-2">Quantity (kwh)</label>
                            <input type="number" className="form-control" value={quantity?.energyquantity} onChange={(e) => handleQuantity(e)} placeholder='30 kwh' />
                        </div>

                        <UserModal btnText="Buy Now" id="Buy Now" customClasses="confirm_btn" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                            <div>
                                <h3 className='text-center mb-4'>Are you sure, want to buy?</h3>
                                <div className="d-flex">
                                    <button onClick={buyEnergy} className='btn confirm_btn'>Yes, I'm</button>
                                    <button onClick={handleClose} className='btn confirm_btn' style={{ backgroundColor: "#2d2727" }}>No, I don't</button>

                                </div>
                            </div>
                        </UserModal>
                        {/* <button className="btn">Buy Now</button> */}

                    </div>
                </div>
            </section>
        </>
    )
}

export default BuyElectricity
